import { Box } from "@mui/material";
import { StatusBadge } from "../../atoms/StatusBadge";
import { SearchableDropdown } from "../../components/SearchableDropdown";

type StatusFieldProps = {
  value: string | null;
  onChange: (newVal: string | null) => void;
  choices: string[];
  edit?: boolean;
  disabled?: boolean;
};

export const StatusField = ({ value, onChange, choices, edit, disabled }: StatusFieldProps) => {
  const isEmpty = !value || value === "";
  return (
    <>
      {!isEmpty && !edit && <StatusBadge status={value as any} />}
      {edit && (
        <SearchableDropdown
          value={value}
          onChange={onChange}
          getOptions={(search: string) =>
            choices.filter((option) => option.toLowerCase().includes(search.toLowerCase()))
          }
          getOptionLabel={(option) => ""}
          isOptionEqualToValue={(a, b) => a === b}
          startAdornment={
            !!value ? (
              <Box display="flex" alignItems="center">
                <StatusBadge status={value as any} />
              </Box>
            ) : null
          }
          renderOption={(props, option) => {
            return <StatusBadge status={option as any} />;
          }}
          disabled={disabled}
        />
      )}
    </>
  );
};
